import {CommonBuildConfigurationInput as BuildConfigurationInput} from '../commonConfiguration.types'

import {MixConfiguration} from './types'

export const buildMixConfiguration = ({
  options,
  featureToggles
}: BuildConfigurationInput): MixConfiguration => {
  const validContracts = options.contracts.map((contract) => ({
    ...contract,
    selectableDateRange: contract.dateRange, // not sure why we are doing that?
    materials: contract.materials
  }))
  const materials = validContracts.flatMap((contract) =>
    contract.materials.map((material) => ({...material, contractNumber: contract.contractNumber}))
  )

  return {
    mix: {
      materials,
      contracts: validContracts,
      restrictMaterialsToSelectedContract: !!featureToggles.enableContractSelection
    }
  }
}
